import i18n from "i18next"
import {initReactI18next} from "react-i18next"
import en from "./en"
import fr from "./fr"

export const SUPPORTED_LANGUAGES = ["fr", "en"] as const

export type Language = typeof SUPPORTED_LANGUAGES[number]

/** Where the chosen language is kept, so a visitor is not asked twice */
export const LANGUAGE_STORAGE_KEY = "score-vision-language"

/**
 * The language the app opens in.
 *
 * A choice already made wins, then the browser, and French is what is left: the plans, the prices
 * and the support are sold in French, so it is the language of the app rather than its fallback.
 */
export const initialLanguage = (): Language => {
    try {
        const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY) as Language

        if (SUPPORTED_LANGUAGES.includes(stored))
            return stored
    } catch (e) {
        // A browser that refuses storage still gets a language
    }

    return navigator.language?.split("-")[0] === "en" ? "en" : "fr"
}

i18n.use(initReactI18next)
    .init({
        resources: {
            en: {translation: en},
            fr: {translation: fr}
        },
        lng: initialLanguage(),
        fallbackLng: "fr",
        interpolation: {
            escapeValue: false
        }
    })

export default i18n
